import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const fundValuationDaySelector = ({ fundValuationDay }: ReducerState) => fundValuationDay;
export const fundValuationDayLoadingSelector = createSelector(
  fundValuationDaySelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
